<template>
  <header class="docgo-brand">
    <img class="image" src="/static/images/base/new-docgo-logo-white.svg" alt="Logo DocGo">
    <h4 class="slogan">Sistema de criação, tramitação e assinatura de documentos eletrônicos</h4>
  </header>
</template>

<script>
export default {
  name: 'DocgoBrand',
};
</script>

<style scoped lang="scss">
.docgo-brand {
  & {
    text-align: center;
  }

  > .image {
    margin-bottom: 1rem;
    width: 140px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/base/DocgoBrand.vue